module.exports = __webpack_public_path__ + "static/ArchiveVideo01-91c0ab973c0edc9e68c57ddf52ac427f.mp4";